import React from 'react';

const SarasViewSwitch = (props) => {
    const { viewSwitcher, ctrlKey, hideMode, children } = props;

    const isComponentVisible = viewSwitcher.isComponentVisible(ctrlKey);

    if (!isComponentVisible && hideMode === 'soft') {
        return (
            <div style={{ display: 'none' }}>
                {children}
            </div>
        )
    }
    else if(isComponentVisible) {
        return (
            <div>
                {children}
            </div>
        )
    }
    else
        return(null)
}

export default SarasViewSwitch